<template>
  <div class="register-client">
    <form class="client-form">
      <div class="form__title">Заказать товар</div>

      <label class="search-label">

        <input
          type="text"
          name="company"
          autocomplete="off"
          placeholder="Клиент"
          v-model.trim="company"
          @input="findClient"
          :class="{ error: $v.company.$dirty && !$v.company.required }"
        />

        <div class="search-result">
          <p
            v-for="(result, index) in searchResult"
            @click="filInfo(index)"
            :key="index"
          >
            {{ result.title }}
          </p>
        </div>

      </label>

      <label class="error" v-if="$v.company.$dirty && !$v.company.required"
        >Поле 'Клиент' не должно быть пустым</label
      >


      <input
        type="date"
        name="replacementDate"
        class="replacementDate"
        placeholder="Дата Презентации дд.мм.гггг"
        v-model.trim="replacementDate"
        :class="{ error: $v.replacementDate.$dirty && !$v.replacementDate.required }"
      />
      <label
        class="error"
        v-if="$v.replacementDate.$dirty && !$v.replacementDate.required"
        >Поле 'Дата' не должно быть пустым</label
      >

      <input
        type="submit"
        value="начать работу"
        id="registerClient"
        v-on:click.prevent="sendForm"
      />
    </form>
  </div>
</template>
<script>
import { required } from "vuelidate/lib/validators"; //валидатор

export default {
  data: () => ({
    company: "",
    clientID: "",
    place: "",
    replacementDate: "",
    searchResult: [],
    realClient: false   //Проверка, на то, что клиент существующий и выбран из списка с помощью поиска, а не просто введен в текстовое поле
  }),
  validations: {
    company: { required },
    replacementDate: { required }
  },
  methods: {
    sendForm() {

      if (this.$v.$invalid) {
        this.$v.$touch();
        return;
      }
      // else if(!this.realClient){

      //   this.$makeToast(
      //     "Ошибка!!!",
      //     "danger",
      //     `Такого клиента не существует! Введите имя еще раз`
      //   );
      //   return;
      // }
      else {
        this.$localStorageSet('miniCart', {})  //Очистить корзину, на случай если в ней что-то еще осталось
        let currentClientInfo = {
          companyId: this.clientID,
          datePresentation: this.replacementDate
        }
        this.$localStorageSet('currentClientInfo', currentClientInfo);
        this.$router.push('/shop-pre-catatlog')
      }
    },
    findClient(e) {
      let that = this;
      if (e.target.value.length >= 4) {
        this.$store
          .dispatch("COMPANY_SEARCH", this.company)
          .then((response) => {
            that.searchResult = response.data.data;
          });
      } else {
        that.searchResult = [];
      }
    },
    filInfo(index) {
      let choice = this.searchResult[index];
      this.company = choice.title;
      this.clientID = choice.id;
      this.searchResult = [];
    },
  }
};
</script>
<style lang="scss" scoped>
.presentationDate::-webkit-inner-spin-button {
  display: none;
}
.client-form {
  justify-content: flex-start;
  padding-top: 50px;
}
input:not(#registerClient) {
  padding-left: 10px;
}
input[type="date"]::-webkit-calendar-picker-indicator {
  background: url("https://cdn3.iconfinder.com/data/icons/linecons-free-vector-icons-pack/32/calendar-16.png")
    center 80% no-repeat;
  color: rgba(0, 0, 0, 0);
  opacity: 1;
}
input[type="submit"] {
  position: fixed;
  bottom: 0;
  margin-bottom: 0;
  width: 100%;
  left: 0;
}
.search-label {
  margin: 0;
  position: relative;
}
.search-result {
  width: 100%;
  background: #fff;
  position: absolute;
  top: 50%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  max-height: 400px;
  overflow-y: auto;
  p {
    padding: 10px;
    font-size: 14px;
  }
}
</style>